import { cn } from "../lib/cn";
import { Icon } from "./Icon";

export interface SpinnerProps {
  size?: number;
  className?: string;
  /** Screen-reader text. Pass an empty string when the spinner sits inside a labelled control. */
  label?: string;
}

export function Spinner({ size = 18, className, label = "Loading" }: SpinnerProps) {
  return (
    <span
      role={label ? "status" : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn("inline-flex", className)}
    >
      <Icon name="loader" size={size} className="animate-spin" />
    </span>
  );
}
